export const SET_DIAMOND_STATS = 'SET_DIAMOND_STATS';
export const SET_ROUGH_DIAMOND_STATS = 'SET_ROUGH_DIAMOND_STATS';
export const SET_ROUGH_DIAMOND_GROUP_STATS = 'SET_ROUGH_DIAMOND_GROUP_STATS';
